var x = (w, k, t) => new Promise((S, l) => {
  var L = (o) => {
    try {
      m(t.next(o));
    } catch (u) {
      l(u);
    }
  }, V = (o) => {
    try {
      m(t.throw(o));
    } catch (u) {
      l(u);
    }
  }, m = (o) => o.done ? S(o.value) : Promise.resolve(o.value).then(L, V);
  m((t = t.apply(w, k)).next());
});
import { a as p, u as H, m as O, v as W, o as j, b as A, c as a, e as n, F as d, g, h as i, t as R, w as C, i as c, f as v, k as D, x as U, j as z } from "./define-element-XpjsV6s1.js";
import { u as G } from "./use-user-CwEHAZOt.js";
import { u as J } from "./use-config-1FCHS5th.js";
import { I } from "./Input-yplyeePD.js";
import { B as b } from "./Button-D5lKR5Sd.js";
import { L as K } from "./Link-Ck5HVnu-.js";
import { _ as Q } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const X = ["innerHTML"], Y = { class: "grouped" }, Z = ["textContent"];
var M, T;
const ee = {
  __name: "LoginForm",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    loginText: {
      type: String,
      default: "Login"
    },
    loggingInText: {
      type: String,
      default: "Logging in..."
    },
    email: {
      type: String,
      default: ""
    },
    // Where to navigate after a successful login — defaults to the same
    // accountUrl AccountLogin.vue's "Account" link points at, so a login form
    // with no config at all lands the customer somewhere sensible. Pass an
    // empty string to disable the redirect and only rely on the "loggedIn"
    // emit instead.
    redirectUrl: {
      type: String,
      default: (T = (M = window.OFFSET) == null ? void 0 : M.accountUrl) != null ? T : "/account"
    }
  },
  emits: ["loggedIn"],
  setup(w, { emit: k }) {
    const t = w, S = k, { config: l } = J(), { loginMutation: L, logoutMutation: V, resetPassword: m } = G(), {
      // mutateAsync, not mutate — mutate() doesn't reliably return a promise
      // that resolves only once the mutation (and its onSuccess side effects,
      // e.g. use-user.ts's invalidateQueries) has actually completed, which
      // onSubmit below depends on before emitting "loggedIn".
      mutateAsync: o,
      isPending: u,
      isError: $,
      error: F
    } = L, { mutate: te, isPending: oe } = V, s = p(t.email), P = p(""), B = H("container"), f = p(!1), y = p(!1), _ = p(!1), N = O(() => `Please${W(l.value.company_phone) ? "" : ` call ${l.value.company_phone} or`} email <a href="mailto:${l.value.company_email}">${l.value.company_email}</a> if you need any further assistance.`);
    function h(E) {
      return x(this, null, function* () {
        if (f.value) {
          yield q();
          return;
        }
        try {
          yield o({ email: s.value, password: P.value });
        } catch (e) {
          return;
        }
        S("loggedIn"), t.redirectUrl && (window.location.href = t.redirectUrl);
      });
    }
    function q() {
      return x(this, null, function* () {
        s.value && (y.value = !0, yield m(s.value), _.value = !0, y.value = !1);
      });
    }
    return j(() => {
      A(B.value, t.inheritStyle);
    }), (E, e) => (a(), n("form", {
      onSubmit: U(h, ["prevent"]),
      ref: "container",
      class: "offset-login-form"
    }, [
      f.value ? (a(), n(d, { key: 0 }, [
        _.value ? (a(), n(d, { key: 0 }, [
          e[5] || (e[5] = g("p", null, " We've sent you an email with a link to reset your password. We recommend checking your spam folder if you do not receive it after a few minutes. ", -1)),
          g("p", { innerHTML: N.value }, null, 8, X)
        ], 64)) : (a(), n(d, { key: 1 }, [
          e[7] || (e[7] = g("p", null, " Please enter the primary email address associated with your account, and we will promptly send you an email containing a secure link to reset your password. ", -1)),
          i(I, {
            type: "email",
            modelValue: s.value,
            "onUpdate:modelValue": e[0] || (e[0] = (r) => s.value = r),
            label: "Email",
            required: "",
            floating: !0
          }, null, 8, ["modelValue"]),
          g("div", Y, [
            i(b, {
              type: "submit",
              disabled: y.value,
              textContent: R(
                y.value ? "Resetting Password..." : "Reset Password"
              )
            }, null, 8, ["disabled", "textContent"]),
            i(b, {
              variant: "alt",
              onClick: e[1] || (e[1] = (r) => f.value = !1)
            }, {
              default: C(() => e[6] || (e[6] = [
                c("Cancel", -1)
              ])),
              _: 1,
              __: [6]
            })
          ])
        ], 64))
      ], 64)) : (a(), n(d, { key: 1 }, [
        i(I, {
          type: "email",
          modelValue: s.value,
          "onUpdate:modelValue": e[2] || (e[2] = (r) => s.value = r),
          label: "Email",
          required: "",
          floating: !0
        }, null, 8, ["modelValue"]),
        i(I, {
          type: "password",
          modelValue: P.value,
          "onUpdate:modelValue": e[3] || (e[3] = (r) => P.value = r),
          label: "Password",
          required: "",
          floating: !0
        }, null, 8, ["modelValue"]),
        v($) ? (a(), n("em", {
          key: 0,
          class: "error",
          role: "alert",
          textContent: R(v(F).message)
        }, null, 8, Z)) : D("", !0),
        i(K, {
          onClick: e[4] || (e[4] = U((r) => f.value = !0, ["prevent"]))
        }, {
          default: C(() => e[8] || (e[8] = [
            g("strong", null, "Help", -1),
            c(", I forgot my password.", -1)
          ])),
          _: 1,
          __: [8]
        }),
        z(E.$slots, "actions", { isLoggingIn: v(u) }, () => [
          i(b, { type: "submit" }, {
            default: C(() => [
              v(u) ? (a(), n(d, { key: 0 }, [
                c("Logging in...")
              ], 64)) : (a(), n(d, { key: 1 }, [
                c("Login")
              ], 64))
            ]),
            _: 1
          })
        ], !0)
      ], 64))
    ], 544));
  }
}, me = /* @__PURE__ */ Q(ee, [["__scopeId", "data-v-d5d8400f"]]);
export {
  me as L
};
